import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    this.compactMode = false
    this.init()

    // Set up a MutationObserver to watch for DOM changes
    this.setupMutationObserver()
  }

  init() {
    // Load compact mode from localStorage, default to false
    const savedCompactMode = localStorage.getItem('tv-program-compact-mode')
    this.compactMode = savedCompactMode ? savedCompactMode === 'true' : false
    this.applyCompactMode()
  }

  setupMutationObserver() {
    // Watch for changes in the program grid
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          // Apply compact mode to any new programs that were added
          this.applyCompactMode()
        }
      })
    })

    // Start observing the program grid
    const programGrid = document.querySelector('[data-controller*="program-filter"]')
    if (programGrid) {
      observer.observe(programGrid, {
        childList: true,
        subtree: true
      })
    }
  }

  toggle() {
    this.compactMode = !this.compactMode
    this.saveCompactMode()
    this.applyCompactMode()
  }

  saveCompactMode() {
    localStorage.setItem('tv-program-compact-mode', this.compactMode.toString())
  }

  applyCompactMode() {
    const descriptions = document.querySelectorAll('.program-description')
    const subtitles = document.querySelectorAll('.program-subtitle')
    const ratings = document.querySelectorAll('.program-rating')

    descriptions.forEach(el => {
      if (this.compactMode) {
        el.classList.add('hidden')
      } else {
        el.classList.remove('hidden')
      }
    })

    subtitles.forEach(el => {
      if (this.compactMode) {
        el.classList.add('hidden')
      } else {
        el.classList.remove('hidden')
      }
    })

    ratings.forEach(el => {
      if (this.compactMode) {
        el.classList.add('hidden')
      } else {
        el.classList.remove('hidden')
      }
    })

    this.updateIcon()
  }

  updateIcon() {
    if (this.hasIconTarget) {
      if (this.compactMode) {
        // Expanded view icon
        this.iconTarget.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"/>'
      } else {
        // Compact view icon
        this.iconTarget.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>'
      }
    }
  }
}